import { call, put, takeLatest } from "redux-saga/effects";
import {updateWfoDays} from "../http/requests/setupWFODays";
import {
    setVtrackLoader,
  } from "../redux/actions";

  import { SettingDataType } from "../redux/actions";
  import{getWfoList, setWfoList} from "../redux/actions/settings"

  function* workerupdateWFODaysSaga({payload}) {
    try {
      yield put(setVtrackLoader(true));
      const wfoList = yield call(updateWfoDays,payload)
      yield put(getWfoList(payload))
      yield put(setWfoList(wfoList));
      yield put(setVtrackLoader(false));
    } catch (err) {
      console.log(err);
      yield put(setVtrackLoader(false));
    }
  };
  
  export function* updateWFODaysSaga() {
    yield takeLatest(
      SettingDataType.UPDATE_WFO_LIST,
      workerupdateWFODaysSaga
    );
  };
  
